import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { ModalCadastroPerguntasPage } from '../modais/modal-cadastro-perguntas/modal-cadastro-perguntas';


import { CadastroPerguntasService } from '../../providers/cadastro-perguntas-service';
import { AlertService } from '../../providers/alert-service';

/*
  Generated class for the CadastroPerguntas page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-cadastro-perguntas',
  templateUrl: 'cadastro-perguntas.html',
  providers: [
    CadastroPerguntasService
  ]
})
export class CadastroPerguntasPage {

  categoriasCadastroPerguntas: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private alertService: AlertService, public modalCtrl: ModalController, private cadastroPerguntasService: CadastroPerguntasService) {
    this.listarTodasPerguntas();
  }

  listarTodasPerguntas() {
    this.cadastroPerguntasService.obterListaPerguntas().subscribe(data => {
      this.categoriasCadastroPerguntas = data;
    }, error => {
      this.alertService.mostraAlerta("Houve um erro listar perguntas.", error);
      console.log("erro: " + error)
    });
  }


  public cadastrarPergunta(categoria) {

    let modal = this.modalCtrl.create(ModalCadastroPerguntasPage, { param1: "Cadastrar Pergunta para categoria " + categoria.dsCategoriaQuestao, param2: "" });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {
        let pergunta = {
          idCategoriaQuestao: categoria.idCategoriaQuestao,
          idQuestao: 0,
          idQuestaoResposta: 0,
          peso: 1,
          titulo: retornoModal.titulo,
          flInversao: retornoModal.flInversao,
          notaExplicativa: retornoModal.notaExplicativa
        };
        this.cadastroPerguntasService.salvarPergunta(categoria.idCategoriaQuestao, pergunta).subscribe(data => {
          this.alertService.mostraAlerta("", "Pergunta cadastrada com sucesso.");
          this.listarTodasPerguntas();
        }, error => {
          this.alertService.mostraAlerta("", "Houve um erro ao cadastrar pergunta.");
          console.log("erro: " + error)
        });
      }
    });
    modal.present();
  }

  public cadastrarCategoria() {
    
    let modal = this.modalCtrl.create(ModalCadastroPerguntasPage, { param1: "Cadastrar Categoria", param2: "" });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {
        let categoria = {
          dsCategoriaQuestao: retornoModal,
          idCategoriaQuestao: ""
        };
        this.cadastroPerguntasService.salvarCategoria(categoria).subscribe(data => {
          this.alertService.mostraAlerta("", "Categoria cadastrada com sucesso.");
          this.listarTodasPerguntas();
        }, error => {
          this.alertService.mostraAlerta("", "Houve um erro ao cadastrar categoria.");
          console.log("erro: " + error)
        });
      }
    });
    modal.present();
  }


  editarPergunta(pCategoria, pergunta) {

    let modal = this.modalCtrl.create(ModalCadastroPerguntasPage, { param1: "Editar Pergunta", param2: pergunta });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {

        // let perguntaAdd = this.categoriasCadastroPerguntas.filter((categoria) => categoria.idCategoriaQuestao == pCategoria.idCategoriaQuestao).map((categoria) => {
        //   return categoria.perguntas.filter((questao) => questao.idQuestao == pergunta.idQuestao).map((questao) => {

        let objeto = {
          idCategoriaQuestao: pCategoria.idCategoriaQuestao,
          idQuestao: pergunta.idQuestao,
          idQuestaoResposta: pergunta.idQuestaoResposta,
          peso: 1,
          titulo: retornoModal.titulo,
          flInversao: retornoModal.flInversao,
          notaExplicativa: retornoModal.notaExplicativa
        };

        this.cadastroPerguntasService.salvarPergunta(pCategoria.idCategoriaQuestao, objeto).subscribe(data => {
          this.alertService.mostraAlerta("", "Pergunta editada com sucesso.");
          this.listarTodasPerguntas();
        }, error => {
          this.alertService.mostraAlerta("", "Houve um erro ao editar pergunta.");
          console.log("erro: " + error)
        });       
      }

    });
    modal.present();
  }


  excluirPergunta(perguntaId) {
    this.cadastroPerguntasService.excluirPergunta(perguntaId).subscribe(data => {
      this.alertService.mostraAlerta("", "Exclusão de pergunta com sucesso.");
      this.listarTodasPerguntas();
    }, error => {
      this.alertService.mostraAlerta("", "Houve um erro ao excluir pergunta.");
      console.log("erro: " + error)
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/cadastro-perguntas/cadastro-perguntas.ts